import httpClient from "Api/httpClient";

const END_POINT = "/logs";

const getLogs = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getLog = (log_id) => {
    if (!log_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + log_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printLog = (log_id) => {
    if (!log_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?log_id=" + log_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createLogs = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateLogs = (payload, log_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + log_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteLogs = (log_id) => {
    const DELETE_END_POINT = END_POINT + "/" + log_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getLogs, getLog, printLog, createLogs, updateLogs, deleteLogs };
